export default __webpack_public_path__ + "static/media/logo2.5c48abb1.jpg";